import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { useRootStore } from '../../../../providers/root-store-provider';
import { routes } from '../../../../config/routes';
import { IconNext } from '../../../../components/app/icons/next';
import { WebButton as Button } from '../../../../components/web/button/web-button';
import { getBooleanQueryParam } from '../../../../utils/get-boolean-query-param';

type AccountType = {
    inverse?: boolean;
    expanded?: boolean;
    onAuthAction?: (action: () => void) => void;
};

export const Account: React.FC<AccountType> = observer(({ inverse, expanded = false, onAuthAction }) => {
    const { t } = useTranslation();
    const rootStore = useRootStore();
    const { authStore } = rootStore;
    const router = useRouter();

    useEffect(() => {
        if (getBooleanQueryParam(router.query.login)) {
            authStore.authDialogStore.setLoginActive();
        }
    }, [router.query]);

    const openAuth = (action: () => void) => (onAuthAction ? onAuthAction(action) : action());

    return (
        <div className="flex items-center gap-xxsmall md:gap-small">
            {rootStore.cookieService.hasJwtToken() && (
                <Button
                    size={expanded ? 'large' : 'medium'}
                    block={expanded}
                    nativeLink
                    href={routes.app.index}
                    icon={<IconNext />}
                    iconGap="xsmall"
                    variant="secondary"
                >
                    {t('pages.layout.header.goToApp')}
                </Button>
            )}
            {!rootStore.cookieService.hasJwtToken() && (
                <>
                    <Button
                        tone={inverse ? 'brand' : 'neutral'}
                        variant={inverse ? 'white' : 'secondary'}
                        variation={inverse ? 'transparent' : 'outlined'}
                        size={expanded ? 'large' : { sm: 'small', md: 'medium' }}
                        block={expanded}
                        onClick={() => openAuth(() => authStore.authDialogStore.setLoginActive())}
                    >
                        {t('pages.layout.header.signIn')}
                    </Button>
                    <Button
                        variant="secondary"
                        size={expanded ? 'large' : { sm: 'small', md: 'medium' }}
                        block={expanded}
                        onClick={() => {
                            openAuth(() => authStore.authDialogStore.setSignupActive());
                        }}
                    >
                        {t('pages.layout.header.tryItForFree')}
                    </Button>
                </>
            )}
        </div>
    );
});
